import { render, staticRenderFns } from "./form-add-printer.vue?vue&type=template&id=e1354660"
import script from "./form-add-printer.vue?vue&type=script&lang=js"
export * from "./form-add-printer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports